export function omitEmpty<T extends Record<string, any>>(source: T) {
  const cleaned: any = {};
  Object.keys(source || {}).forEach((key) => {
    const value = (source as any)[key];

    if (value === undefined) return;
    if (typeof value === 'string' && value.trim() === '') return;

    cleaned[key] = value;
  });
  return cleaned as Partial<T>;
}

export function formatExperience(minimumExperience: string | number): string {
  const experience = typeof minimumExperience === 'string' ? 
    parseInt(minimumExperience) : 
    minimumExperience;
    
  if (!experience || experience === 0) {
    return 'Indiferente';
  }
  
  if (experience === 1) {
    return '1 ano';
  }
  
  return `${experience} anos`;
}
